import { render, staticRenderFns } from "./mblist.vue?vue&type=template&id=46aece7a&scoped=true&"
import script from "./mblist.vue?vue&type=script&lang=js&"
export * from "./mblist.vue?vue&type=script&lang=js&"
import style0 from "./mblist.vue?vue&type=style&index=0&id=46aece7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aece7a",
  null
  
)

export default component.exports